(function () {
    window.WCCP_DEBUG = window.WCCP_DEBUG || {};
    window.WCCP_DEBUG.STATE = window.WCCP_DEBUG.STATE || window.STATE || null;

    const READY_CHECK_MS = 50;
    const READY_TIMEOUT_MS = 15000;


    function getCompIndexById(cid) {
        const list = WCCP_DEBUG.STATE?.data?.components || [];
        return list.findIndex(c => Number(c.id) === Number(cid));
    }

    function hideAllStepsExceptIndex(indexToShow) {
        const steps = document.querySelectorAll('.' + CLASSES.step.split(' ').join('.'));
        // steps.forEach((s, i) => { s.style.display = (i === indexToShow ? 'block' : 'none'); });
        steps.forEach((s, i) => {
            const show = i === indexToShow;
            s.style.display = show ? 'block' : 'none';

            if (show) {
                s.dataset._wasVisible = '1';
            }
        });
        if (indexToShow >= 0 && steps[indexToShow]) updateStepNavButtons?.(steps[indexToShow]);
    }

    function clearSelectionForComponentId(cid) {
        delete WCCP_DEBUG.STATE.selected?.[cid];
        delete WCCP_DEBUG.STATE.selectedVariants?.[cid];

        const idSel = (window.CSS && CSS.escape) ? CSS.escape(String(cid)) : String(cid);
        const step = document.querySelector(`[data-item_id="${idSel}"]`);
        if (step) {
            step.querySelectorAll('.' + CLASSES.option.split(' ').join('.'))
                .forEach(o => o.classList.remove(CLASSES.selected));

            step.querySelectorAll('.wccp-variation-select').forEach(sel => {
                if (sel.value) {
                    sel.value = '';
                    sel.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }

        const summary = document.querySelector('#summary .summary__list');
        const li = summary?.querySelector(`[data-component-id="${cid}"]`);
        if (li) li.remove();
    }

    function clearDownstreamFromIndex(startIdx) {
        const comps = WCCP_DEBUG.STATE?.data?.components || [];
        for (let i = startIdx + 1; i < comps.length; i++) {
            clearSelectionForComponentId(Number(comps[i].id));
        }
    }

    window.WCCP_SUMMARY_CLEAR = clearDownstreamFromIndex;

    function updateProgressSafe() {
        const summary = document.querySelector('#summary .summary__list');
        const total = WCCP_DEBUG.STATE?.data?.components?.length || 0;
        const selectedNow = summary ? summary.querySelectorAll('.summary__item').length : 0;
        const pct = total ? Math.round((selectedNow / total) * 100) : 0;
        const bar = document.querySelector('.summary__progress');
        if (bar) bar.style.width = pct + '%';
    }

    function getComponentVisibilityStatus(cid) {
        cid = Number(cid);

        const step = document.querySelector(`[data-item_id="${cid}"]`);

        if (!step) {
            // console.debug('[SUMMARY][HIDDEN] step not found', cid);
            return 'hidden';
        }

        let allowedSet = null;
        try {
            allowedSet = computeAllowedByComponent?.().get(cid);
        } catch (e) {}

        const allowedCount = allowedSet ? allowedSet.size : 0;

        if (!allowedCount) {
            // console.debug('[SUMMARY][HIDDEN][SCENARIO] no allowed options', cid);
            return 'hidden';
        }

        const pid = WCCP_DEBUG.STATE?.selected?.[cid];
        const isCurrentlyShown = step.style.display !== 'none';
        const isSingleAllowed = allowedCount === 1;

        if (pid && !isCurrentlyShown && isSingleAllowed) {
            // console.debug('[SUMMARY][AUTO-SKIPPED]', cid, { pid, allowedCount });
            return 'auto-skipped';
        }

        // console.debug('[SUMMARY][VISIBLE]', cid, { allowedCount });
        return 'visible';
    }

    function isComponentsReady() {
        return !!(window.WCCP_DEBUG.STATE && window.WCCP_DEBUG.STATE.data && Array.isArray(WCCP_DEBUG.STATE.data.components) && WCCP_DEBUG.STATE.data.components.length);
    }

    function waitForComponents() {
        return new Promise((resolve, reject) => {
            const t0 = Date.now();
            if (isComponentsReady()) return resolve();

            const onReadyEvent = () => {
                if (isComponentsReady()) {
                    cleanup();
                    resolve();
                }
            };

            const iv = setInterval(() => {
                if (isComponentsReady()) {
                    cleanup();
                    resolve();
                } else if (Date.now() - t0 > READY_TIMEOUT_MS) {
                    cleanup();
                    reject(new Error('[SUMMARY] timeout waiting for components'));
                }
            }, READY_CHECK_MS);

            function cleanup() {
                clearInterval(iv);
                document.removeEventListener('wccp:ready', onReadyEvent, true);
            }

            document.addEventListener('wccp:ready', onReadyEvent, true);
        });
    }

    function ensureList() {
        const aside = document.getElementById('summary');
        if (!aside) return null;
        let ul = aside.querySelector('.summary__list');
        if (!ul) {
            ul = document.createElement('ul');
            ul.className = 'summary__list';
            ul.setAttribute('role', 'list');
            aside.appendChild(ul);
        }
        return ul;
    }

    function setupSummary() {
        const summary = ensureList();
        if (!summary) return;

        const comps = WCCP_DEBUG.STATE.data.components;

        function createItem(comp, valueText) {
            const li = document.createElement('li');
            li.className = 'summary__item';
            li.dataset.key = (comp.name || '').toLowerCase().replace(/\s+/g, '_');
            li.dataset.componentId = String(comp.id);
            li.innerHTML = `
        <div class="summary__meta">
          <span class="summary__label">${comp.title || comp.name || 'Component'}</span>
          <span class="summary__value">${valueText || 'Not selected'}</span>
        </div>
        <button class="summary__edit" type="button">Edit</button>
      `;
            const editBtn = li.querySelector('.summary__edit');
            if (editBtn) {
                editBtn.addEventListener('click', () => {
                    if (isConstructorBusy()) {
                        // console.warn('[SUMMARY] Edit blocked: constructor is busy', comp.id);
                        return;
                    }

                    const cid = Number(comp.id);
                    const idx = getCompIndexById(cid);

                    clearDownstreamFromIndex(idx);

                    applyVisibilityFrom?.(idx - 1);

                    hideAllStepsExceptIndex(idx);

                    window.WCCP_SUMMARY_UPDATE?.();

                    if (window.WCCP_CONSTRUCTOR_UPDATE) {
                        window.WCCP_CONSTRUCTOR_UPDATE();
                    }

                    updateProgressSafe();
                });
            }
            return li;
        }

        function formatValue(comp) {
            const cid = Number(comp.id);
            const pid = WCCP_DEBUG.STATE.selected?.[cid];
            const vid = WCCP_DEBUG.STATE.selectedVariants?.[cid];
            const prod = (comp.products || []).find(p => Number(p.product_id || p.id) === Number(pid));
            if (!prod) return 'Not selected';
            if (vid && Array.isArray(prod.variations)) {
                const v = prod.variations.find(vr => Number(vr.variation_id || vr.id) === Number(vid));
                if (v?.attributes) {
                    const txt = Object.values(v.attributes).filter(Boolean).join(' / ');
                    if (txt) return txt;
                }
            }
            return prod.name || 'Not selected';
        }

        function renderList() {
            const summary = ensureList();
            if (summary) summary.innerHTML = '';
            updateProgress();
        }

        function ensureItemFor(comp, valueText) {
            const summary = ensureList();
            if (!summary) return;
            let li = summary.querySelector(`[data-component-id="${comp.id}"]`);
            if (!li) {
                li = createItem(comp, valueText);
                const all = [...summary.querySelectorAll('.summary__item')];
                const compIndex = WCCP_DEBUG.STATE.data.components.findIndex(c => Number(c.id) === Number(comp.id));
                const after = all.find(el => {
                    const id = Number(el.getAttribute('data-component-id'));
                    const idx = WCCP_DEBUG.STATE.data.components.findIndex(c => Number(c.id) === id);
                    return idx > compIndex;
                });
                if (after) summary.insertBefore(li, after);
                else summary.appendChild(li);
            } else {
                const val = li.querySelector('.summary__value');
                if (val) val.textContent = valueText || 'Not selected';
            }
        }

        function removeItemFor(comp) {
            const summary = ensureList();
            if (!summary) return;
            const li = summary.querySelector(`[data-component-id="${comp.id}"]`);
            if (li) li.remove();
        }

        function updateProgress() {
            const summary = ensureList();
            if (!summary) return;
            const totalSelectable = WCCP_DEBUG.STATE.data.components.length;
            const selectedNow = summary.querySelectorAll('.summary__item').length;
            const pct = totalSelectable ? Math.round((selectedNow / totalSelectable) * 100) : 0;
            const bar = document.querySelector('.summary__progress');
            if (bar) bar.style.width = pct + '%';
        }

        function isConstructorBusy() {
            try {
                return !!(window.WCCP_LOADING && typeof WCCP_LOADING.active === 'function' && WCCP_LOADING.active());
            } catch (e) {
                return false;
            }
        }

        function updateValues() {
            const comps = WCCP_DEBUG.STATE.data?.components || [];
            comps.forEach(comp => {
                const cid = Number(comp.id);
                const pid = WCCP_DEBUG.STATE.selected?.[cid];

                if (pid) {
                    const vid = WCCP_DEBUG.STATE.selectedVariants?.[cid];
                    const prod = (comp.products || []).find(p => Number(p.product_id || p.id) === Number(pid));
                    const value = (() => {
                        if (!prod) return 'Not selected';
                        if (vid && Array.isArray(prod.variations)) {
                            const v = prod.variations.find(vr => Number(vr.variation_id || vr.id) === Number(vid));
                            const txt = v?.attributes ? Object.values(v.attributes).filter(Boolean).join(' / ') : '';
                            if (txt) return txt;
                        }
                        return prod.name || 'Not selected';
                    })();

                    const status = getComponentVisibilityStatus(cid);

                    // console.groupCollapsed(`[SUMMARY] component ${cid}`);
                    // console.log('status:', status);
                    // console.log('selected product:', pid);
                    // console.groupEnd();

                    if (status === 'visible') {
                        ensureItemFor(comp, value);
                    } else {
                        removeItemFor(comp);
                    }
                } else {
                    removeItemFor(comp);
                }

            });

            updateProgressSafe();
        }

        document.addEventListener('click', (e) => {
            if (e.target?.closest?.('.component_option_thumbnail_container') ||
                e.target?.closest?.('.wccp-variation-select')) {
                setTimeout(updateValues, 0);
            }
        }, true);

        document.addEventListener('change', (e) => {
            if (e.target?.classList?.contains('wccp-variation-select') ||
                e.target?.matches?.('select')) {
                setTimeout(updateValues, 0);
            }
        }, true);

        const reset = document.querySelector('.summary__reset');
        if (reset) {
            reset.addEventListener('click', (e) => {
                e.preventDefault();

                if (isConstructorBusy()) {
                    reset.style.cursor = 'not-allowed';
                    // console.warn('[SUMMARY] Reset blocked: constructor is busy');
                    return;
                }

                const comps = WCCP_DEBUG.STATE?.data?.components || [];

                comps.forEach(c => clearSelectionForComponentId(Number(c.id)));

                const summary = document.querySelector('#summary .summary__list');
                if (summary) summary.innerHTML = '';

                if (ConstructorRenderer && ConstructorRenderer.reset) {
                    ConstructorRenderer.reset();
                }

                applyVisibilityFrom?.(-1);

                hideAllStepsExceptIndex(0);

                if (window.WCCP_CONSTRUCTOR_UPDATE) {
                    window.WCCP_CONSTRUCTOR_UPDATE();
                }

                updateProgressSafe();
            });
        }



        renderList();

        window.WCCP_SUMMARY_UPDATE = updateValues;
    }

    waitForComponents()
        .then(setupSummary)
        .catch((err) => console.warn(String(err)));

    document.addEventListener('wccp:ready', () => {
        if (isComponentsReady()) {
            try { setupSummary(); } catch (e) { console.error(e); }
        }
    }, false);
})();
